import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import AssetTypeDataGrid from '../AssetTypeDataGrid';
import AssetTypeList from '../AssetTypeList';

const AssetTypes: React.FC = () => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <AssetTypeDataGrid />
      </If>
      <If condition={!isDesktop}>
        <AssetTypeList />
      </If>
    </>
  );
};

export default React.memo(AssetTypes);
